import { Injectable } from '@angular/core';
import {  HttpClient, HttpHeaders, HttpRequest, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {School, Year, Grade, Class, Subject, SchoolCategory, Country, Region, User, Role} from '../model/school.model';

import { environment } from '../../environments/environment';

@Injectable()
export class SchoolService {
  headers: any;
  options: any;

  constructor( private http: HttpClient) {
    const headersItem = new HttpHeaders({
      'Content-Type': 'application/json',
      // Authorization: 'CTL ' + localStorage.getItem('token')
    });
    this.headers = headersItem;
  }

  detail(schoolId: string): Observable<School[]> {
    // add header
    this.options = {headers: this.headers};
    // get users from ap
    return this.http.get(environment.restAPI + 'school/' + schoolId, this.options)
        .pipe(map((response: any) => response ));
  }


  getYearList(project_id?: string): Observable<Year[]> {

    // add header
    this.options = {headers: this.headers};
    // get users from ap
    return this.http.get(environment.restAPI + 'years', this.options)
      .pipe(map((response: any) => response));

  }

  getSubjectList(projectId?: string): Observable<Subject[]> {

    // add header
    this.options = {headers: this.headers};
    // get users from ap
    return this.http.get(environment.restAPI + 'subjects', this.options)
      .pipe(map((response: any) => response));
  }

  getProjectSubjectList(projectId?: string): Observable<Subject[]> {
    this.options = {headers: this.headers};
    return this.http.get(environment.restAPI + 'project/' + projectId, this.options)
            .pipe(map((response: any) => response));
  }

  /* get class subject also */
  getGradeList(schoolId?: string): Observable<Grade[]> {
    let params = new HttpParams();
    if (schoolId) {
      params = params.set('school_id', schoolId);
    }
    this.options = {headers: this.headers, params};
    // get users from ap
    return this.http.get(environment.restAPI + 'grades', this.options)
      .pipe(map((response: any) => response));
  }

  getClassList(schoolId?: string): Observable<Class[]> {
    let params = new HttpParams();
    if (schoolId) {
      params = params.set('school_id', schoolId);
    }
    this.options = {headers: this.headers, params};
    // get users from ap
    return this.http.get(environment.restAPI + 'classes', this.options)
      .pipe(map((response: any) => response));

  }

  /* grade list should suffice, remove me */
  getGradeClassList(schoolId?: string): Observable<Grade[]> {

    // add header
    this.options = {headers: this.headers};
    // get users from ap
    return this.http.get(environment.restAPI + 'classes/grades', this.options)
      .pipe(map((response: any) => response ));

  }

  /* add grade list with class detail */
  addGradeClass(data: any, schoolId?: string) {

    let params = new HttpParams();

    params = params.set('bulk', 'y');
    params = params.set('classes', 'y');

    if (schoolId) {
      params = params.set('school_id', schoolId);
    }

    this.options = {headers: this.headers, params};
    // get users from ap
    return this.http.post(environment.restAPI + 'class', data, this.options)
        .pipe(map((response: any) => response));
  }

  updateGradeClass(grade_id: string, data: any, school_id?: string) {

    // add header
    
    let params = new HttpParams();

    params = params.set('classes', 'y');
    if (school_id) {
      params = params.set('school_id', school_id);
    }

    this.options = {headers: this.headers, params};
    // get users from ap
    return this.http.put(environment.restAPI + 'grade/' + grade_id, data, this.options)
      .pipe(map((response: any) => response ));

  }

  addGradeSubject(data: any, school_id?: string) {
    let params = new HttpParams();

    params = params.set('bulk', 'y');
    params = params.set('subjects', 'y');

    if (school_id) {
      params = params.set('school_id', school_id);
    }

    this.options = {headers: this.headers, params};
    // get users from ap
    return this.http.put(environment.restAPI + 'grade', data, this.options)
        .pipe(map((response: any) => response));

  }

  updateGradeSubject(grade_id: string, data: any, school_id?: string) {

    // add header
    
    let params = new HttpParams();

    params = params.set('subjects', 'y');
    if (school_id) {
      params = params.set('school_id', school_id);
    }

    this.options = {headers: this.headers, params};
    // get users from ap
    return this.http.put(environment.restAPI + 'grade/' + grade_id, data, this.options)
      .pipe(map((response: any) => response));

  }

  assignTeacher(data: any) {
    let params = new HttpParams();

    params = params.set('bulk', 'y');
    params = params.set('assign', 'y');

    this.options = {headers: this.headers, params};
    // get users from ap
    return this.http.put(environment.restAPI + 'user', data, this.options)
      .pipe(map((response: any) => response ));

  }

  assignSubjectTeacher(data: any[]) {

    // add header // update class update API to handle this
    
    let params = new HttpParams();

    params = params.set('bulk', 'y');
    params = params.set('assign', 'y');

    this.options = {headers: this.headers, params};
    // get users from ap
    return this.http.put(environment.restAPI + 'class', data, this.options)
      .pipe(map((response: any) => response ));
  }

  updateClassSubjectAssignment(user_id: string, data: any) {
    let params = new HttpParams();

    params = params.set('assign', 'y');

    this.options = {headers: this.headers, params};
    // get users from ap
    return this.http.put(environment.restAPI + 'user/' + user_id, data, this.options)
      .pipe(map((response: any) => response ));

  }

  uploadAddTeachersNStudentExcel(data: any) {

    // add header
    this.options = {headers: this.headers};
    // get users from ap
    return this.http.post(environment.restAPI + 'provision/users', data, this.options)
      .pipe(map((response: any) => response.json() ));

  }

  checkForNewClasses(params) {

    return this.http.post(environment.restAPI + 'checkForNewClasses',
       params, {}).pipe(map(res => res ));

  }

  getSubjectListFromObjectIds(params) {
     return this.http.post(environment.restAPI + 'getSubjectListFromObjectId',
       params, {}).pipe(map(res => res));
  }

  getTeacherList(params) {
    return this.http.post(environment.restAPI + 'getTeacherList_SA',
      params , {}).pipe(map(res => res));
  }

  finalStepForSetupYourSchool(params, isEditMode) {
    let apiName;
    if (isEditMode) {
      apiName = 'editSetUpYourSchool';
    } else {
      apiName = 'copyTempCollectionToUsers';
    }
    return this.http.post(environment.restAPI + apiName,
       params, {}).pipe(map(res => res));
  }

  downloadTemplate() {

    return this.http.get(environment.restAPI + 'downloadAddStudentsAndTeachersTemplate',
       {}).pipe(map(res => res ));

  }

  getGradeandClassesForSchool(schoolCode) {
    return this.http.get(environment.restAPI + 'getGradeandClassesForSchool?schoolCode=' + schoolCode,
        {}).pipe(map(res => res));
  }

  getListOfGradewiseSubjects(schoolCode) {

    const params = {
      schoolCode
    };
    // add header
    this.options = {headers: this.headers};
    // get users from ap
    return this.http.post(environment.restAPI + 'grades', this.options)
      .pipe(map(res => res));

  }

  getAssignedTeacherListForEdit(schoolCode) {

    const params = {
      schoolCode
    };
    return this.http.post(environment.restAPI + 'fetchTeacherSubjectMappingGradeClasswise',
    params, {}).pipe(map(res => res));

  }

}
